import React from 'react'
import AudioPlayer from 'react-h5-audio-player'

type Props = {
  recording: string
}

const Player: React.FC<Props> = ({ recording }) => {
  return (
    <AudioPlayer
      src={recording}
      // preload={'none'}
      showJumpControls={false}
      customAdditionalControls={[]}
      onPlayError={e => console.error('Player play error', e)}
      onError={e => console.error('Player error', e)}
    />
  )
}

export default Player
